// import { SeccionPlano } from '../domain/seccionPlano';
import { SeccionPlano } from 'interiores-mapa';
import { Constantes } from './constantes';

export class SeccionFormulario {

	Id: string;
	IdAlternativo: string;
	Nombre: string;
	Descripcion: string;
	Color: any;
	ColorHover: any;
	IdAla: string;
	Idiomas: Map<string, SeccionIdiomaFormulario> = new Map<string, SeccionIdiomaFormulario>();
	potenciaTx: Number;
	FechaAlta: Date;
	FechaBaja: Date;

	SECCION_PLANO: SeccionPlano = SeccionPlano.createInstance();

	TIPOLOGIAS_SECCION: any[];

	// Objeto de Breeze
	ENTIDAD: any;
	TIPO: string;
	numeroCONTENIDOS: Number = 0;
	nivelSeccion: Number = 0;

	// constructor(seccionPlano?: SeccionPlano, idAla?: string) {
	constructor( idAla?: string ) {
		this.IdAla = idAla;

		this.Id = '';
		this.IdAlternativo = '';
		this.Nombre = '';
		this.Descripcion = '';
		this.Color = {r: 0, g: 0, b: 0, a: 0 };
		this.ColorHover = '';
		this.FechaAlta = null;
		this.FechaBaja = null;

		this.SECCION_PLANO = SeccionPlano.createInstance();
		this.TIPOLOGIAS_SECCION = [];
		this.ENTIDAD = {};
	}

	fromSeccionPlano(seccionPlano: SeccionPlano): SeccionFormulario{
		this.SECCION_PLANO = seccionPlano;

		if (this.SECCION_PLANO.ENTIDAD) {
			return this.fromENTIDAD(this.SECCION_PLANO.ENTIDAD);
		}

		return this;
	}

	fromENTIDAD(ENTIDAD: any): SeccionFormulario{
		this.ENTIDAD = ENTIDAD;

		this.Id = this.ENTIDAD.Id;
		this.IdAlternativo = this.ENTIDAD.IdAlternativo;
		this.Nombre = this.ENTIDAD.Nombre;
		this.Descripcion = this.ENTIDAD.Descripcion;
		this.FechaAlta = ENTIDAD.FechaAlta;
		this.FechaBaja = ENTIDAD.FechaBaja;

		let stringColor = this.ENTIDAD.Color;
		if (stringColor) {
			const arrayColor = stringColor.split('rgba(')[1].split(')')[0].split(',');
			const objetoColor =  {r: arrayColor[0], g: arrayColor[1], b: arrayColor[2], a: arrayColor[3] };
			this.Color = objetoColor;
		}
		else {
			stringColor = Constantes.seccionFill; // 'rgba(64, 255, 0, 1)';
			const arrayColor = stringColor.split('rgba(')[1].split(')')[0].split(',');
			const objetoColor =  {r: arrayColor[0], g: arrayColor[1], b: arrayColor[2], a: arrayColor[3]  };
			this.Color = objetoColor;
		}

		this.ColorHover = this.ENTIDAD.ColorHover;
		this.TIPO = this.ENTIDAD .constructor.name.split('_', 2)[0];
		if (this.ENTIDAD.CONTENIDOS) {
			this.numeroCONTENIDOS = this.ENTIDAD.CONTENIDOS.length;
		}

		this.ENTIDAD.IDIOMAS.forEach(element => {
			const aux = new SeccionIdiomaFormulario(element);
			this.Idiomas.set(element.IDIOMA.Codigo, aux);
		});

		if (this.ENTIDAD.TIPOLOGIAS && this.ENTIDAD.TIPOLOGIAS.length > 0) {
			this.ENTIDAD.TIPOLOGIAS.forEach(element => {
				this.TIPOLOGIAS_SECCION.push(element.TIPOLOGIA_SECCION);
			});
		}

		return this;
	}

}

export class SeccionIdiomaFormulario {

	Codigo: string;
	Nombre: string;
	Descripcion: string;

	constructor(seccionIdioma?) {

		if (seccionIdioma) {
			this.Codigo = seccionIdioma.IDIOMA.Codigo ? seccionIdioma.IDIOMA.Codigo : '';
			this.Nombre = seccionIdioma.Nombre ? seccionIdioma.Nombre : '';
			this.Descripcion = seccionIdioma.Descripcion ? seccionIdioma.Descripcion : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
			this.Descripcion = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/SeccionFormulario.ts